export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail',
      invalidEmailOrUsername: 'Invalid e-mail',
      invalidPassword: 'Invalid password',
      logInToPlanka: 'Log in to Kanban',
      noInternetConnection: 'No internet connection',
      pageNotFound_title: 'Page Not Found',
      password: 'Password',
      projectManagement: 'Project management',
      serverConnectionFailed: 'Server connection failed',
      unknownError: 'Unknown error, try again later',
    },

    action: {
      logIn: 'Log in',
    },
  },
};
